// src/api/modulesApi.js
import axios from "axios";

export const updateCompany = async (updatedCompany) => {
  try {
    const response = await axios.put(`http://localhost:8080/webnet-hms/api/company/update/`, updatedCompany);
    console.log(response.data);
    window.alert("Company Updated.");
  } catch (error) {
    window.alert("Error updating company:", error);
    throw error;
  }
};

export const updateCompanyStatus = async (id,activate) => {
  try {
    const response = await axios.put(`http://localhost:8080/webnet-hms/api/company/active/${id}`,activate);
    console.log(response.data);
    window.alert("Company activation status updated.");
  } catch (error) {
    window.alert("Error updating company:", error);
    throw error;
  }
};
